import { render, staticRenderFns } from "./Acceptance_form.vue?vue&type=template&id=f78c6fdc&"
import script from "./Acceptance_form.vue?vue&type=script&lang=js&"
export * from "./Acceptance_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports